<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { Switch } from '@collector/shared-ui'
import { YesNoEnum } from '@collector/sportsapi-client-legacy'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEvent } from '@desktop/views/Relation/composables'

import { injectSuccessBadge } from '../../successBadge'

// inject
const { showSuccessBadge } = injectSuccessBadge()

// composables
const { event } = useEvent()

// state
const modelValue = ref<boolean>()

// computed
const isEventNeutralVenue = computed(
  () => event.value.neutral_venue === YesNoEnum.Yes,
)

// init
watch(modelValue, async (newValue) => {
  if (newValue === isEventNeutralVenue.value) {
    // event.neutral_venue updated in background
    return
  }

  const neutralVenueUpdateValue = (newValue ? 1 : 0) as unknown as YesNoEnum

  await sportsApiClient.Events.patch(event.value.id, {
    event: { neutral_venue: neutralVenueUpdateValue },
  })

  showSuccessBadge()
})

watch(
  isEventNeutralVenue,
  () => {
    modelValue.value = isEventNeutralVenue.value
  },
  { immediate: true },
)
</script>

<template>
  <Switch
    v-model="modelValue"
    class="justify-end"
    size="xs"
  >
    Neutral venue
  </Switch>
</template>
